import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/esg/esgNine/img1.webp";
import img2 from "../../../assets/img/esg/esgNine/img2.webp";
import arrow from "../../../assets/img/esg/esgNine/arrow2.webp";

function EsgNine() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
      <div id="esgNine" className={`esgNine ${isVisible ? "visible" : ""}`}>
        <div className="esgNineText">
          <div className="social">
            {/* <h1 className={`${isVisible ? 'visible' : ''}`}>Sinerghia Social</h1> */}
          </div>
          <div className="politica">
            <h2 className={`${isVisible ? "visible" : ""}`}>
              {t("esg_nine_h2")}
            </h2>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("esg_nine_text")}
            </p>
          </div>
          <div className="links">
            {/* <a
              href="#esgOne"
              reloadDocument
              className={`link1 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" />
              <p>{t("esg_nine_link1")}</p>
            </a> */}
            <a
              href="#esgSeven"
              reloadDocument
              className={`link2 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" />
              <p>{t("esg_nine_link2")}</p>
            </a>
            <a
              href="#esgSeven"
              reloadDocument
              className={`link2 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" />
              <p>{t("esg_nine_link3")}</p>
            </a>
            <a
              href="#esgSeven"
              reloadDocument
              className={`link2 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" />
              <p>{t("esg_nine_link4")}</p>
            </a>
            <a
              href="#esgSeven"
              reloadDocument
              className={`link2 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" />
              <p>{t("esg_nine_link5")}</p>
            </a>
            <a
              href="#esgSeven"
              reloadDocument
              className={`link2 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" />
              <p>{t("esg_nine_link6")}</p>
            </a>
            <a
              href="#esgSeven"
              reloadDocument
              className={`link2 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" />
              <p>{t("esg_nine_link7")}</p>
            </a>
            <a
              href="#esgSeven"
              reloadDocument
              className={`link2 ${isVisible ? "visible" : ""}`}
            >
              <img src={arrow} alt="" />
              <p>{t("esg_nine_link8")}</p>
            </a>
          </div>
        </div>
        <div className={`esgNineLogo ${isVisible ? "visible" : ""}`}>
          <img src={img1} alt="" width={"350px"} />
          <img src={img2} alt="" width={"350px"} />
        </div>
      </div>
    </VisibilitySensor>
  );
}
export default EsgNine;
